export default __webpack_public_path__ + "static/2-2b352e78ebbf17fc12894a1aeddd02bc.jpg";